import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IChannelRepository } from '../../repositories/interfaces/iChannelRepository';
import { IChannelEntity, IGetChannelsParams } from '../../../entity/interface/iChannels';
import ResponseError from '../../entities/errors/ResponseError';
import { IApiPathManager } from '../../../infrastructures/config/ApiPathManager';
import { API_IDS } from '@intigral/constant';

export interface IGetAllChannelsUseCase {
    execute(params: IGetChannelsParams): Promise<IChannelEntity[]>;
}

export class GetAllChannelsUseCase implements IGetAllChannelsUseCase {
    // Lazy getters for dependencies to avoid circular dependencies
    private get channelsRepo(): IChannelRepository {
        return container.resolve<IChannelRepository>(DI.REPOSITORIES.IChannelRepository);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(params: IGetChannelsParams): Promise<IChannelEntity[]> {
        const response = await this.channelsRepo.getChannels(params);
        if (typeof response.data !== 'undefined') {
            return response.data.channels || [];
        }
        if (typeof response.error !== 'undefined') {
            const path = this.apiPathManager.getPath(API_IDS.CONTENT_CHANNELS);
            throw new ResponseError(
                { url: path },
                {
                    code: response.error.code || 0,
                    message: response.error.msg || 'Unknown error',
                }
            );
        }
        return [];
    }
}
